/**
 * Generate dynamic expiration text based on current date
 * If current date is before August 15th of current year, show current year
 * If current date is after August 15th of current year, show next year
 */
export const getDynamicExpirationText = (): string => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const august15CurrentYear = new Date(currentYear, 7, 15); // Month is 0-indexed, so 7 = August

  let targetYear: number;

  if (currentDate <= august15CurrentYear) {
    // Current date is before or on August 15th of current year
    targetYear = currentYear;
  } else {
    // Current date is after August 15th of current year
    targetYear = currentYear + 1;
  }

  return `Copy link expiring 8/15/${targetYear}`;
};
